var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('pt-branch-company-form',{ref:"form",staticClass:"pt-branch-company-form__withData",attrs:{"BranchCompanyDetail":_vm.BranchCompanyDetail,"isEdit":_vm.isEdit,"Business":_vm.Business,"addressList":_vm.areaList}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }